<app-guest-container [isShowLanguageSelector]="false">
  <div class="title">
    <h1 i18n="@@verify.verifying">Verifying</h1>
  </div>
  <app-loader containerClass="no-margin"></app-loader>
</app-guest-container>
